import { render, staticRenderFns } from "./OwnerGroupSelectModal.vue?vue&type=template&id=94e64014&scoped=true&"
import script from "./OwnerGroupSelectModal.vue?vue&type=script&lang=ts&"
export * from "./OwnerGroupSelectModal.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerGroupSelectModal.vue?vue&type=style&index=0&id=94e64014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e64014",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabItem,VTabsItems})
